import React from 'react';
import {Clock} from 'lucide-react';
import {CreditInfo} from '../../models/creditInfo.model';
import {displayValue} from '../../../../Presentation/utils/displayUtils';

interface CreditInfoAdditionalInfoProps {
  creditInfo: CreditInfo;
}

export const CreditInfoAdditionalInfo: React.FC<CreditInfoAdditionalInfoProps> = ({
  creditInfo
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="text-sm font-medium text-gray-700 mb-2">الفواتير المتأخرة</h4>
        <p className="text-lg font-bold text-gray-900">{creditInfo.overdueInvoices || 0} فاتورة</p>
      </div>

      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="text-sm font-medium text-gray-700 mb-2">آخر دفع</h4>
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-gray-600" />
          <span className="text-sm text-gray-900">
            {creditInfo.lastPaymentDate
              ? new Date(creditInfo.lastPaymentDate).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
                })
              : 'لا توجد مدفوعات'
            }
          </span>
        </div>
      </div>
    </div>
  );
};
